export default __webpack_public_path__ + "static/media/fooksman-logo.e1fe69a4.png";